export default function customizeInputFile() {
    if (document.getElementById("file") && document.getElementById("file-label") && document.querySelector(".field--upload button")) {
        let input = document.getElementById("file");
        let label = document.getElementById("file-label");
        let button = document.querySelector(".field--upload button");
    
        input.addEventListener("change", () => {
            label.innerText = input.value.replace(/^.*\\/, "");
        });
    
        button.addEventListener("click", (event) => {
            event.preventDefault();
    
            input.click();
        });
    }
}